/** Returns line-segment endpoint pairs outside the eye sphere, without moving domain endpoints. */
export function clipConnectorSegmentNearEye(start, end, eye, radius) {
    if (!Number.isFinite(radius) || radius <= 0)
        throw new Error('Connector eye clipping requires a positive finite radius.');
    const direction = end.map((value, axis) => value - start[axis]);
    const relative = start.map((value, axis) => value - eye[axis]);
    const a = direction.reduce((sum, value) => sum + value * value, 0);
    const c = relative.reduce((sum, value) => sum + value * value, 0) - radius * radius;
    if (a === 0)
        return c < 0 ? [] : [start, end];
    const b = 2 * relative.reduce((sum, value, axis) => sum + value * direction[axis], 0);
    const discriminant = b * b - 4 * a * c;
    if (discriminant <= 0)
        return [start, end];
    const root = Math.sqrt(discriminant);
    const enter = Math.max(0, (-b - root) / (2 * a));
    const exit = Math.min(1, (-b + root) / (2 * a));
    if (enter >= exit)
        return [start, end];
    const at = (t) => [
        start[0] + direction[0] * t, start[1] + direction[1] * t, start[2] + direction[2] * t,
    ];
    return [...(enter > 0 ? [start, at(enter)] : []), ...(exit < 1 ? [at(exit), end] : [])];
}
